import { useState } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideInvestmentPlan, InvestmentPlanFormData, InvestmentPlanApiData } from './types'

export const useInvestmentPlanUpdate = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isUpdating, setIsUpdating] = useState(false)

  const updateInvestmentPlan = async (
    id: string,
    formData: InvestmentPlanApiData,
    setInvestmentPlan: (investmentPlan: SlideInvestmentPlan) => void,
    resetForm: (data: InvestmentPlanFormData) => void
  ) => {
    if (!id) return

    setIsUpdating(true)

    try {
      const response = await apiClient.business.slideInvestmentUpdateUpdate({
        businessIdeaId: id,
        profitStructure: formData.profitStructure,
        profitStructureItems: formData.profitStructureItems,
        cashFlow: formData.cashFlow,
        cashFlowItems: formData.cashFlowItems,
        financialPlan: formData.financialPlan,
        financialPlanItems: formData.financialPlanItems,
      })

      if (response.data?.investmentPlan) {
        setInvestmentPlan(response.data.investmentPlan)
        showSnackBar(['収益モデルと投資計画を更新しました'], 'success')

        try {
          resetForm({
            profitStructure: response.data.investmentPlan.profitStructure,
            profitStructureItems: JSON.parse(response.data.investmentPlan.profitStructureItems || '[]'),
            cashFlow: response.data.investmentPlan.cashFlow,
            cashFlowItems: JSON.parse(response.data.investmentPlan.cashFlowItems || '[]'),
            financialPlan: response.data.investmentPlan.financialPlan,
            financialPlanItems: JSON.parse(response.data.investmentPlan.financialPlanItems || '[]'),
          })
        } catch (parseError) {
          console.error('JSONパースエラー:', parseError)
          showSnackBar(['収益モデルと投資計画のデータの読み込みに失敗しました。'], 'error')
        }
      }
    } catch (e) {
      console.error('収益モデルと投資計画の更新に失敗しました:', e)
      handleError(e as ApiErrorResponse, showSnackBar)
    } finally {
      setIsUpdating(false)
    }
  }

  return {
    isUpdating,
    updateInvestmentPlan,
  }
}
